import React from "react";

import styles from "../Styles/Global";
import assets from "../assets";
import { client,urlFor } from "../../../client";
function Download({sourceCodeLink,sourceCodeImage,showSource}) {
	return (
		<div className={`${styles.section} ${styles.bgWhite}`}>
			<div
				className={`${styles.subSection} flex-col text-center`}
			>
				{/* <div>
					<h1
						className={`${styles.h1Text} ${styles.blackText}`}
					>
						Download the Source Code
					</h1>
					<p
						className={`${styles.pText} ${styles.blackText}`}
					>
						Get the full source code on GitHub
					</p>
				</div>
				<button disabled ={showSource} className={styles.btnPrimary}>
					<a
						href={sourceCodeLink}
						target="_blank"
						rel="noreferrer"
					>
						Source Code
					</a>
				</button> */}
				<div className={styles.flexCenter}>
					<img
						src={urlFor(sourceCodeImage).url()}
						alt="Source Code Section Image"
						className={styles.fullImg}
					/>
				</div>
			</div>
		</div>
	);
}

export default Download;
